import React from "react";
import { useTranslation } from "react-i18next";

function Button({ value, onClick, style }) {
  const {t} = useTranslation();
  return (
    <div
      onClick={onClick}
      className={`bg-white w-min px-5 py-1 pt-2 font-semibold text-gray-600 cursor-pointer hover:bg-gray-200 duration-300  rounded-lg ${style}`}
      style={{
        boxShadow:
          "0 4px 6px rgba(0, 0, 0, 0.1), 0 1px 3px rgba(0, 0, 0, 0.06)",
      }}
    >
      {t(value)}
    </div>
  );
}
export default Button;
